import React, { useEffect, useState } from "react";
import "../assets/OnboardLicense.css";
import "../assets/OnboardedSolutionDetails.css";
import { fetchData, postFormData} from "../api/restapi";
import ConfirmationDialog from "../popups/ConfirmationDialog";
import Popup from "../popups/popup";


function OnboardedSolutionDetailsTab() {
    const [solutions, setSolutions] = useState([]);
    const [detailsPopup, setDetailsPopup] = useState(null);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [selectedSolutionId, setSelectedSolutionId] = useState(null);

    const solutionColumns = [
        { key: "solutionId", label: "Solution Id", isClickable: true },
        { key: "description", label: "Solution Description" },
        { key: "state", label: "State" },
        { key: "action", label: "Action", isAction: true }
    ];

    useEffect(() => {
        const params = { state: "CREATED" };
        fetchData(`/qfm/v1/solutions/portal/solutions?state=${params.state}`).then((data) => {
            setSolutions(data.solutions || []);
        });
    }, []);

    const handleStateChange = (slnID) => {
        setSelectedSolutionId(slnID);
        setShowConfirmation(true);
    };

    const handleConfirm = () => {
        const formData = new FormData();
        formData.append("solutionId", selectedSolutionId);

        postFormData("/qfm/v1/solutions/state", formData)
            .then(() => {
                setSuccessMessage("Solution Certified successfully!");
                setSolutions((prevSolutions) => prevSolutions.filter((sol) => sol.solutionId !== selectedSolutionId));
            })
            .catch((err) => {
                console.error("Error changing state", err);
                setErrorMessage("There was an error in certifying the solution.");
            });

        setShowConfirmation(false);
    };

    const handleCancel = () => {
        setShowConfirmation(false);
    };

    const closePopup = () => {
        setSuccessMessage("");
        setErrorMessage("");
        window.location.reload();
    };

    const openDetailsPopup = (solutionId, licenses = [], mbns = []) => {
        setDetailsPopup({ solutionId, licenses, mbns });
    };

    const closeDetailsPopup = () => {
        setDetailsPopup(null);
    };

    return (
        <div className="osln-tab-container">
            {detailsPopup && <div className="overlay"></div>}
            <div className="tab-heading">
                <h1>Solutions in Created State</h1>
            </div>
            <table className="solutions-table">
                <thead>
                    <tr>
                        {solutionColumns.map((col) => (
                            <th key={col.key}>{col.label}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {solutions.map((solution) => (
                        <tr key={solution.solutionId}>
                            {solutionColumns.map((col) => {
                                if (col.isClickable) {
                                    return (
                                        <td
                                            key={col.key}
                                            className="clickable"
                                            onClick={() => openDetailsPopup(solution.solutionId, solution.licenses, solution.mbns)}
                                        >
                                            {solution[col.key]}
                                        </td>
                                    );
                                }

                                if (col.isAction) {
                                    return (
                                        <td key={col.key}>
                                            <button
                                                className="change-state-button"
                                                onClick={() => handleStateChange(solution.solutionId)}
                                            >
                                                Certify
                                            </button>
                                        </td>
                                    );
                                }

                                return <td key={col.key}>{solution[col.key] || col.defaultValue || ""}</td>;
                            })}
                        </tr>
                    ))}
                </tbody>
            </table>

            {detailsPopup && (
                <div className="details-popup">
                    <div className="popup-content">
                        <h3>License Details for Solution ID #{detailsPopup.solutionId}</h3>
                        <table className="details-table">
                            <thead>
                                <tr>
                                    {[
                                        { key: "licenseId", label: "License Id" },
                                        { key: "description", label: "License Description" },
                                        { key: "chipset", label: "Chipset", defaultValue: "-" },
                                        { key: "oem", label: "OEM", defaultValue: "-" },
                                        { key: "features", label: "Features" },
                                    ].map((col) => (
                                        <th key={col.key}>{col.label}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {detailsPopup.licenses.map((license) => (
                                    <tr key={license.licenseId}>
                                        <td>{license.licenseId}</td>
                                        <td>{license.description}</td>
                                        <td>{license.chipset || "-"}</td>
                                        <td>{license.oem || "-"}</td>
                                        <td>{license.features.map((feature) => feature.description).join(", ")}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                        <div className="spacing" />

                        <h3>Delta MBN Details for Solution ID #{detailsPopup.solutionId}</h3>

                        <table className="details-table">
                            <thead>
                                <tr>
                                    {[
                                        { key: "mbnFileId", label: "Delta MBN File Id" },
                                        { key: "description", label: "Delta Description" },
                                        { key: "mbnIdHash", label: "Delta MBN ID Hash" },
                                        { key: "fileName", label: "File Name" },
                                        { key: "chipset", label: "Chipset", defaultValue: "-" },
                                    ].map((col) => (
                                        <th key={col.key}>{col.label}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {detailsPopup.mbns.map((mbn) => (
                                    <tr key={mbn.mbnFileId}>
                                        <td>{mbn.mbnFileId}</td>
                                        <td>{mbn.description}</td>
                                        <td>{mbn.mbnIdHash || "-"}</td>
                                        <td>{mbn.fileName || "-"}</td>
                                        <td>{mbn.chipset || "-"}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <button className="close-popup-button" onClick={closeDetailsPopup}>Close</button>
                    </div>
                </div>
            )}

            {showConfirmation && (
                <ConfirmationDialog
                    message={`Are you sure you want to certify Solution ID #${selectedSolutionId}?`}
                    onConfirm={handleConfirm}
                    onCancel={handleCancel}
                />
            )}

            {successMessage && (
                <Popup message={successMessage} onClose={closePopup} />
            )}

            {errorMessage && (
                <Popup message={errorMessage} onClose={closePopup} />
            )}
        </div>
    );
}

export default OnboardedSolutionDetailsTab;